<div class="product-grid row">
  <div class="product-card col-6 col-sm-4 col-md-3 handPointer feed_css store_css" *ngFor="let store of storeList; let i = index">
    <owl-carousel-o *ngIf="isInitialized" [options]="customOptions">
      <ng-container *ngFor="let item of store?.productArray">
        <ng-template carouselSlide>
          <div class="product-card__image-wrapper" (click)="userDetails ? storeRedirect(store) : onExploreClick($event, 'XDGE Store')">
            <img [ngSrc]="item.preview" alt="Solid XDGE T-Shirt" class="product-card__image" fill />

            <button class="product-card__wishlist-button" role="button" aria-label="badge" *ngIf="lock(store)">
              <div [innerHTML]="ICONS.icBadge | safeHtml"></div>
            </button>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
    <div class="product-card__info" (click)="userDetails ? storeRedirect(store) : onExploreClick($event, 'XDGE Store')">
      <h3 class="product-card__name ellipsis">
        {{ store.node.title }}
      </h3>
      <img
        *ngIf="showLevel(store.node.tags, i)"
        [src]="'../../../../assets/images/levels/ic_' + store.reorderedLevels[0] + '.svg'"
        [alt]="store.reorderedLevels[0]"
        data-toggle="tooltip"
        data-placement="bottom"
        title="{{ store.reorderedLevels[0] | titlecase }}"
        class="badge_assigned"
      />
      <p class="product-card__price">
        {{ removeDecimal(store.node.priceRange.minVariantPrice.amount) | currency: store.node.priceRange.minVariantPrice.currencyCode : 'symbol' }}
      </p>
    </div>
  </div>

  <div class="searchResult" *ngIf="pagination.row == 0 && pagination.text != 'Loading...'">
    <div class="searching text-center">
      <h5>{{ pagination.text || '' }}</h5>
    </div>
  </div>
</div>
